// extracted by mini-css-extract-plugin
export default {"manual":"dashboard-manual-step_manual__Zaqh7","item":"dashboard-manual-step_item__qTkRT","text":"dashboard-manual-step_text__jt2Wf"};